// extracted by mini-css-extract-plugin
module.exports = {"pillarParent":"Pillar_pillarParent___YCpD","pillarImage":"Pillar_pillarImage__45TVs","pillarTitle":"Pillar_pillarTitle__BFPi6","pillarBody":"Pillar_pillarBody__mKxWk"};